import contentDisposition from 'content-disposition'

export function downloadCsv(csvContent: Blob, fileName: string) {
  const url = URL.createObjectURL(csvContent)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName || 'download.csv'
  document.body.appendChild(link)

  link.click()

  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export const parseResponseFileName = (
  headers: Headers,
  defaultFileName: string,
): string => {
  try {
    const headerBody = headers.get('content-disposition')

    if (!headerBody) {
      return defaultFileName
    }

    const parsedContentDisposition = contentDisposition.parse(headerBody)
    const fileName = parsedContentDisposition.parameters['filename']

    if (typeof fileName !== 'string' || fileName.trim() === '') {
      return defaultFileName
    }

    return fileName
  } catch {
    return defaultFileName
  }
}
